var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('formatted-money',{attrs:{"value":_vm.totalPrice}}),_vm._v(" "),(_vm.isAnnual)?_c('span',[_vm._v("per year")]):_c('span',[_vm._v("per month")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }